export { default } from './TradeIncentiveBanner';
